import { Injectable } from "@angular/core";
import { Http, Headers, Response, RequestOptions } from "@angular/http";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";
import "rxjs/add/operator/map";
import { Customer } from "../_models/customer";
import { AuthenticationService } from "../_services/authentication.service";
import { EnvironmentService } from "./index";
import { Dealer } from "app/_models/dealer";
import { Car } from "app/_models/car";

@Injectable()
export class CustomersService {
  private baseUrl: string = this.environmentService.getBaseURL() + "/api";

  constructor(
    private http: Http,
    private authenticationService: AuthenticationService,
    private environmentService: EnvironmentService
  ) {}

  findByChassisNumberAndEmail(
    chassisNumber: string,
    email: string
  ): Observable<Customer> {
    let customer = this.http
      .get(
        `${this.baseUrl}/customer-search?chassisNumber=${chassisNumber}&customerEmail=${email}`,
        this.makeHeaders()
      )
      .map(mapCustomer)
      .catch(handleError);
    return customer;
  }

  setPermission(permissionStatus, mauticId: string): Observable<Response> {
    return this.http.post(
      `${this.baseUrl}/customer-permission`,
      { permissionStatus: permissionStatus, mauticId: mauticId },
      this.makeHeaders()
    );
  }

  // new change -- here add did is dealerid. now this function for perticular dealer
  getAll(did): Observable<Customer[]> {
    let customers$ = this.http
      // new change -- here api in pass dealer id
      .get(
        `${this.baseUrl}/customers?populate=car&dealer=${did}`,
        this.makeHeaders()
      )
      .map(mapCustomers)
      .catch(handleError);
    return customers$;
  }
  get(id: string): Observable<Customer> {
    let customer$ = this.http
      .get(`${this.baseUrl}/customers/${id}`, this.makeHeaders())
      .map(mapCustomer);
    return customer$;
  }
  create(customer: Customer): Observable<Customer> {
    if (customer.chassisnumber != null) {
      customer.chassisnummer = customer.chassisnumber;
    }
    let newcustomer = this.http
      .post(
        `${this.baseUrl}/customers`,
        JSON.stringify(customer),
        this.makeHeaders()
      )
      .map(mapCustomer);
    return newcustomer;
  }

  read(id: string): Observable<Customer> {
    let customer = this.http
      .get(
        `${this.baseUrl}/customers/${id}?populate=car&populate=dealer`,
        this.makeHeadersWithoutAuth()
      )
      .map(mapCustomer);
    return customer;
  }

  update(customer: Customer): Observable<Response> {
    if (customer.chassisnumber != null) {
      customer.chassisnummer = customer.chassisnumber;
    }
    return this.http.put(
      `${this.baseUrl}/customers/${customer._id}`,
      JSON.stringify(customer),
      this.makeHeaders()
    );
  }
  updateUsedCar(customerId: String): Observable<Response> {
    return this.http.put(
      `${this.baseUrl}/customers/updateUsedCar/${customerId}`,
      this.makeHeaders()
    );
  }

  delete(id: string): Observable<Response> {
    return this.http
      .delete(`${this.baseUrl}/customers/${id}`, this.makeHeaders())
      .map((res: Response) => res.json()) // ...and calling .json() on the response to return data
      .catch((error: any) =>
        Observable.throw(error.json().error || "Server error")
      ); //...errors if any
  }

  getCustomerByRegistration(regNr: string): Observable<Customer[]> {
    let customer = this.http
      .get(
        `${this.baseUrl}/customers?regnr=${regNr}&populate=car&populate=dealer`,
        this.makeHeaders()
      )
      .map(mapCustomers);
    return customer;
  }

  getCustomerByMauticIdent(mauticId: string, dealerId: string): Observable<Customer> {
    let customers = this.http
      .get(
        `${this.baseUrl}/customers?mauticId=${mauticId}&dealer=${dealerId}&populate=car&populate=dealer`,
        this.makeHeaders()
      )
      .map(mapCustomers);
    return customers.map(arr => arr[arr.length-1]);
  }

  getCustomerByMauticIdAndRegistration(
    mauticId: string,
    regNr: string,
    dealerId: string
  ): Observable<Customer> {
    let customer = this.http
      .get(
        `${this.baseUrl}/customers/search-mautic-id-regnr?mauticId=${mauticId}&regNr=${regNr}&dealerId=${dealerId}`
      )
      .map(mapCustomer);
    return customer;
  }

  addinmailchimp(id: string): Observable<Response> {
    return this.http
      .post(
        `${this.baseUrl}/customers/${id}/addinmailchimp`,
        this.makeHeaders()
      )
      .map((res: Response) => res.json()) // ...and calling .json() on the response to return data
      .catch((error: any) =>
        Observable.throw(error.json().error || "Server error")
      ); //...errors if any
  }

  addinmautic(id: string): Observable<Response> {
    return this.http
      .post(`${this.baseUrl}/customers/${id}/addinmautic`, this.makeHeaders())
      .map((res: Response) => res.json()) // ...and calling .json() on the response to return data
      .catch((error: any) =>
        Observable.throw(error.json().error || "Server error")
      ); //...errors if any
  }

  hasMauticSegmentMembership(
    dealerId,
    regnr,
    customerEmail,
    segmentAlias
  ): Observable<boolean> {
    return this.http
      .get(
        `${this.baseUrl}/customers/has-segment-membership?email=${customerEmail}&regnr=${regnr}&dealer=${dealerId}&segment=${segmentAlias}`
      )
      .map(function (response) {
        if (response.status == 200) {
          const json = response.json();
          if (json.hasMembership) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      });
  }

  getAllFromMauticSegmentRaw(segmentId, dealerId): Observable<any[]> {
    return this.http
      .get(
        `${this.baseUrl}/customers/from-mautic-segment/${segmentId}/dealer/${dealerId}`
      )
      .map(mapAny);
  }

  getAllFromMauticSegment(segmentId, dealerId): Observable<any[]> {
    return this.http
      .get(
        `${this.baseUrl}/customers/from-mautic-segment/${segmentId}/dealer/${dealerId}`
      )
      .map(mapCustomers);
  }
  getAllLeadsFromMauticSegment(segmentId, dealerId): Observable<any[]> {
    return this.http
      .get(`${this.baseUrl}/customers/from-mautic-segment/${segmentId}/dealer/${dealerId}`)
      .map(mapAny);
  }

  getFromMauticSegmentAndEmail(segmentId, dealerId, email): Observable<any> {
    return this.http
      .get(
        `${this.baseUrl}/customers/from-mautic-segment/${segmentId}/dealer/${dealerId}/email/${email}`
      )
      .map((response) => response.json());
  }

  getFromMauticContactId(dealerId, id): Observable<any> {
    return this.http
      .get(`${this.baseUrl}/customers/from-mautic-id/dealer/${dealerId}/id/${id}`)
      .map(mapCustomer);

  }

  queryFromMautic(
    segmentId,
    dealerId,
    { attributeName, attributeValue }
  ): Observable<any> {
    return this.http
      .get(
        `${this.baseUrl}/mautic/${dealerId}/${segmentId}?attributeName=${attributeName}&attributeValue=${attributeValue}`
      )
      .map((response) => response.json());
  }

  setCarWorkshopDNC(customer, dncStatus): Observable<Response> {
    return this.http
      .post(
        `${this.baseUrl}/customers/${customer._id}/set-carworkshop-dnc`,
        { carWorkshopDnc: dncStatus },
        this.makeHeaders()
      )
      .map((res: Response) => res.json())
      .catch((error: any) =>
        Observable.throw(error.json().error || "Server error")
      );
  }

  findByRegNumber(regNumber, dealerId): Observable<Response> {
    return this.http.get(
      `${this.baseUrl}/find-customer-by-regnr?regNr=${regNumber}&dealer=${dealerId}`,
      this.makeHeaders()
    );
  }

  findTyreCustomerByRegNumber(regNumber, dealerId): Observable<Response> {
    return this.http.get(
      `${this.baseUrl}/find-tyre-customer-by-regnr?regNr=${regNumber}&dealer=${dealerId}`,
      this.makeHeaders()
    );
  }

  setMauticProperty(mauticId, dealerId, properties): Observable<Response> {
    return this.http.post(`${this.baseUrl}/customers/update-mautic-property`, {
      mauticId: mauticId,
      dealerId: dealerId,
      properties: properties,
    });
  }

  toDbCustomer(r: any, dealerId: string): Customer {
    let customer = new Customer();

    customer._id = r.micar_cust_id ? r.micar_cust_id : null;
    customer.mauticId = r.mauticId ? r.mauticId : r.id;

    switch (dealerId) {
      //Nellemann
      case "5ec7b995f99d985b5e8f02ab":
        customer.name = r.nellemann_navn;
        customer.email = r.email.trim().toLowerCase();
        customer.address = r.nellemann_adresse_bruger;
        customer.postnummer = r.nellemann_postnr;
        customer.by = r.nellemann_bruger_by;
        customer.telefonnummer = r.nellemann_mobilnummer;
        customer.chassisnummer = r.nellemann_chassisnummer;
        customer.regnr = r.nellemann_regnr;
        customer.firstreg = r.nellemann_1reg;
        customer.carmake = r.nellemann_make;
        customer.carmodel = r.nellemann_modeltekst;
        customer.carversion = r.nellemann_version;
        customer.department = r.nellemann_afdeling;
        customer.carKmStand = r.micar_last_service_km;
        customer.last_service_km_date = r.micar_last_service_km_date;
        customer.service_estimate = r.service_estimate;
        break;
      //Elmer
      case "5a217c8c865e0807cb47fa9c":
        customer.name = r.datamann_customer_name;
        customer.email = r.email.trim().toLowerCase();
        customer.address = r.datamann_customer_address;
        customer.postnummer = r.datamann_customer_postal_code;
        customer.by = r.datamann_customer_city;
        break;
      //STS
      case "63591e878c577855251e44b4":
        customer.name = r.sts_bruger_navn;
        customer.email = r.email.trim().toLowerCase();
        customer.address = r.sts_bruger_adress;
        customer.postnummer = r.sts_bruger_postnr;
        customer.by = r.sts_bruger_by;
        customer.telefonnummer = r.sts_bruger_mobil;
        customer.chassisnummer = r.sts_bil_chassisnummer;
        customer.regnr = r.sts_bil_reg_nr;
        customer.firstreg = r.sts_bil_foerste_regdato;
        customer.carmake = r.sts_bil_make;
        customer.carmodel = r.sts_bil_model;
        customer.carversion = r.sts_bil_version;
        customer.carid = r.sts_servicekontrakt_model;
        customer.lastservice = r.sts_eftersyn_sidste;
        customer.firstreg = r.sts_bil_foerste_regdato;
        customer.regnr = r.sts_bil_reg_nr;
        customer.carKmStand = r.sts_bil_km;
        break;
    }

    return customer;
  }

  private makeHeaders(): RequestOptions {
    let headers = new Headers();

    headers.append("Authorization", this.authenticationService.getToken());
    headers.append("Content-Type", "application/json");
    headers.append("charset", "UTF-8 ");
    headers.append("Accept", "application/json");

    let options = new RequestOptions({ headers: headers });
    return options;
  }

  private makeHeadersWithoutAuth(): RequestOptions {
    let headers = new Headers();

    headers.append("Content-Type", "application/json");
    headers.append("charset", "UTF-8 ");
    headers.append("Accept", "application/json");

    let options = new RequestOptions({ headers: headers });
    return options;
  }
}

function mapAny(response: Response): any[] {
  return response.json().map(toAny);
}

function mapCustomers(response: Response): Customer[] {
  // uncomment to simulate error:
  // throw new Error('ups! Force choke!');
  //console.log(response);
  return response.json().map(toCustomer);
}

function toCustomer(r: any): Customer {
  let customer = <Customer>{
    _id: r._id,
    name: r.name,
    email: r.email,
    private: r.private,
    usedCarId: r.usedCarId,
    haspermission: r.haspermission,
    sex: r.sex,
    isleasing: r.isleasing,
    imported: r.imported,
    car: r.car as Car || null,
    registration: r.registration,
    dealer: r.dealer,
    carid: r.sts_servicekontrakt_model,
    raw: r.raw,
    inMailChimp: r.inMailChimp,
    mailChimpId: r.mailChimpId,
    isSubscribed: r.isSubscribed,
    postnummer: r.postnummer ? r.postnummer : r.postalcode,
    postalcode: r.postalcode ? r.postalcode : r.postnummer,
    address: r.address,
    by: r.by ? r.by : r.city,
    city: r.city ? r.city : r.by,
    telefonnummer: r.telefonnummer,
    lead_activities: r.lead_activities,
    micar_term: r.micar_term,
    mauticId: r.mauticId,
    inMautic: r.inMautic,
    service_term: r.service_term,
    department: r.department,
    hotel: r.hotel,
    customerType: r.customerType,
    carWorkshopDnc: r.carWorkshopDnc,
    active: r.active,
    isPrefer: r.isPrefer,
    
    // Car fields
    firstreg: r.firstreg,
    chassisnumber: r.chassisnummer,
    regnr: r.regnr,
    carmake: r.carmake,
    carmodel: r.carmodel,
    carversion: r.carversion,
    carBrand: r.carBrand,
    carYear: r.carYear,
    modelId: r.modelId,

    //Service fields
    lastservice: r.lastservice,
    actualkm: r.actualkm,
    carKmStand: r.last_service_km,
    last_service_km: r.last_service_km,
    last_service_km_date: r.last_service_km_dat,
    service_estimate: r.service_estimate,
    serviceAgreeStart: r.serviceAgreeStart,
    serviceAgreeEnd: r.serviceAgreeEnd,
    serviceAgreeKm: r.serviceAgreeKm,
    hasServiceAgreementData: r.hasServiceAgreementData,
    lastVehicleKmRecord: r.lastVehicleKmRecord,

    //Tyre fields
    hasTireData: r.hasTireData,
    tyre_term: r.tyre_term,
    micar_sommerdaek_maerke: r.micar_sommerdaek_maerke,
    micar_sommerdaek_bredde: r.micar_sommerdaek_bredde,
    micar_sommerdaek_profil: r.micar_sommerdaek_profil,
    micar_sommerdaek_indlever: r.micar_sommerdaek_indlever,
    micar_sommerdaek_diameter: r.micar_sommerdaek_diameter,
    micar_vinterdaek_maerke: r.micar_vinterdaek_maerke,
    micar_vinterdaek_bredde: r.micar_vinterdaek_bredde,
    micar_vinterdaek_profil: r.micar_vinterdaek_profil,
    micar_vinterdaek_diameter: r.micar_vinterdaek_diameter,
    micar_vinterdaek_indlever: r.micar_vinterdaek_indlever,
    micar_daek_cust_id: r.micar_daek_cust_id,
    micar_sommerdaek_bestilt: r.micar_sommerdaek_bestilt,
    micar_sommerdaek_tire_pri: r.micar_sommerdaek_tire_pri,
    micar_sommerdaek_min_pric: r.micar_sommerdaek_min_pric,
    micar_vinterdaek_bestilt: r.micar_vinterdaek_bestilt,
    micar_vinterdaek_tire_pri: r.micar_vinterdaek_tire_pri,
    micar_vintrdaek_min_price: r.micar_vintrdaek_min_price,
    micar_sommerdaek_1_mm: r.micar_sommerdaek_1_mm,
    micar_sommerdaek_2_mm: r.micar_sommerdaek_2_mm,
    micar_sommerdaek_3_mm: r.micar_sommerdaek_3_mm,
    micar_sommerdaek_4_mm: r.micar_sommerdaek_4_mm,
    micar_vinterdaek_1_mm1: r.micar_vinterdaek_1_mm1,
    micar_vinterdaek_2_mm1: r.micar_vinterdaek_2_mm1,
    micar_vinterdaek_3_mm1: r.micar_vinterdaek_3_mm1,
    micar_vinterdaek_4_mm1: r.micar_vinterdaek_4_mm1,
    micar_sommerdaek_status: r.micar_sommerdaek_status,
    micar_vinterdaek_status: r.micar_vinterdaek_status,
    render_winterTyreMatch: r.render_winterTyreMatch,
    render_summerTyreMatch: r.render_summerTyreMatch,
    summerTyre: r.summerTyre,
    winterTyre: r.winterTyre,

    // Lead fields
    lead_handled: r.lead_handled,
    lead_call_status: r.lead_call_status,
    lead_costumer_feedback: r.lead_costumer_feedback,
    lead_costumer_opinion: r.lead_costumer_opinion,
    lead_activity_offer: r.lead_activity_offer,
    lead_activity_mail: r.lead_activity_mail,
    lead_activity_call: r.lead_activity_call,
    selectedItems: r.selectedItems,

    // Tracking fields
    createdAt: r.createdAt,
    updatedAt: r.updatedAt,
    micar_landingpage_calcula1: r.micar_landingpage_calcula1
  };
  return customer;
}

function toAny(r: any): any {
  let object: any;
  object = r;
  return object;
}

function mapCustomer(response: Response): Customer {
  // toPerson looks just like in the previous example
  var json = response.json();
  return toCustomer(json);
}

// this could also be a private method of the component class
function handleError(error: any) {
  // log error
  // could be something more sofisticated
  let errorMsg =
    error.message ||
    `Yikes! There was was a problem with our hyperdrive device and we couldn't retrieve your data!`;
  console.error(errorMsg);

  // throw an application level error
  return Observable.throw(errorMsg);
}



// WEBPACK FOOTER //
// ./src/app/_services/customers.service.ts